module.exports = __webpack_public_path__ + "1b537feb2d439fb340ecc58ac550c2cb.png";